/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  HardpointLoadoutOptionsParams,
  LoadoutOptionList,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Hardpoint Loadout Options
 */
export const hardpointLoadoutOptions = (
    id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<HardpointLoadoutOptionsParams>,
 signal?: AbortSignal
) => {
      id = toValue(id);
params = toValue(params);

      return axiosClient<LoadoutOptionList>(
      {url: `/hardpoints/${id}/loadout-options`, method: 'GET',
        params, signal
    },
      );
    }




export const getHardpointLoadoutOptionsQueryKey = (id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<HardpointLoadoutOptionsParams>,) => {
    return [
    'hardpoints',id,'loadout-options', ...(params ? [params] : [])
    ] as const;
    }


export const getHardpointLoadoutOptionsQueryOptions = <TData = Awaited<ReturnType<typeof hardpointLoadoutOptions>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<HardpointLoadoutOptionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hardpointLoadoutOptions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHardpointLoadoutOptionsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hardpointLoadoutOptions>>> = ({ signal }) => hardpointLoadoutOptions(id,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hardpointLoadoutOptions>>, TError, TData>
}

export type HardpointLoadoutOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof hardpointLoadoutOptions>>>
export type HardpointLoadoutOptionsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Hardpoint Loadout Options
 */

export function useHardpointLoadoutOptions<TData = Awaited<ReturnType<typeof hardpointLoadoutOptions>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<HardpointLoadoutOptionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hardpointLoadoutOptions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHardpointLoadoutOptionsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






